<template>
  <div class="dem-rel-con-res-tab">
    <!-- SETA O STATUS DA TELA -->
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <!-- SETA OS DADOS DA TELA -->
    <div v-else>
      <!-- :cpntApiRouter="route"
      :cpntApiMethods="method"
      :cpntApiWhere="where"
      :cpntApiField="field"
      :cpntApiOrder="order"
      :cpntApiFieldVirtual="fieldVir" -->
      <!-- :cpntBotaoExportar="exportar"
      :cpntSetarValores="demRelPorContatoTabSetarLinhas"
      :cpntBuscaInicial="false" -->
      <App-Tabela :data-time='time'
      :cpntColuna="cpntColunas"
      :cpntLinha="cpntLinhas"
      ref="tabela">
        <!-- COLUNA DEMANDA ID -->
        <template v-slot:col_demandaId="{ linha }">
          <App-Button @onClick='() => { demRelPorContatoTabAbrirDemanda(linha.demandaId, cpntDemanda) }' :cpntClass="linha._demandaBT.class">
            <span v-html="linha._demandaBT.texto"></span>
          </App-Button>
        </template>

        <!-- COLUNA ITEM -->
        <template v-slot:col_item_nome="{ linha }">
          <App-Button v-if="linha.item_status !== undefined" :cpntClass="[ 'btn', 'btn-default', 'bt-link-cadastro' ]" @onClick='() => { demRelPorContatoTabAbrirCadastro(linha, linha) }'>
            <!-- COLOCA O NOME DO CONTATO -->
            <span v-html="linha.item_nome"></span>

            <!-- VERIFICA SE O CONTATO ESTA EXCLUIDO -->
            <b v-if='linha.item_status !== "1"' v-html="' [Excluído]'"></b>
          </App-Button>
        </template>

        <!-- SETA O BOTÃO HISTORICO -->
        <template v-slot:col_historico="{ linha }">
          <!-- SETA O BOTÃO -->
          <App-Button v-if="linha.item_status !== undefined" :cpntClass="[ 'btn', 'btn-info', 'btn-sm' ]" :cpntTexto="'Histórico'" @onClick='() => { demRelPorContatoTabAbrirHistorico(linha) }'></App-Button>

          <!-- SETA O TRAÇO -->
          <span v-else>---</span>
        </template>
      </App-Tabela>
    </div>
  </div>
</template>

<style scoped>
  .dem-rel-con-res-tab-cab {
    text-align: left;
  }
    .dem-rel-con-res-tab-cab > button {
    /* display: inline-block; */
    width: max-content !important;
    min-width: 200px !important;
    text-align: left !important;

    margin: 3px 0px !important;
    padding: 0px 40px 0px 0px !important;
    text-decoration: none !important;
    font-size: var(--font-base-soma-17);
  }

  .dem-rel-con-res-tab > div > table > tbody > tr > td.col_item_nome > div > span > button {
    text-decoration: none !important;
    padding: 3px 10px !important;
  }
  .dem-rel-con-res-tab > div > table > tbody > tr > td.col_item_nome > div > span > button:hover {
    text-decoration: underline !important;
  }
</style>

<style>
  .dem-rel-con-res-tab > div > table > tbody > tr:last-child > td {
    font-weight: bold;
  }
</style>

<script>
  export default {
    props: {
      cpntDemanda: {
        required: true,
        type: String
      },
      cpntColunas: {
        required: true
      },
      cpntLinhas: {
        required: true
      },
      cpntFiltros: {
        required: true,
        type: Object
      },
      // cpntTotais: {
      //   required: true
      // },
      // cpntRpp: {
      //   required: false,
      //   type: Number,
      //   default: function () {
      //     return 20
      //   }
      // },
      // cpntTotal: {
      //   required: true
      // },

      // cpntMontarRouter: {
      //   required: true
      // },
      // cpntMontarMethod: {
      //   required: true
      // },
      // cpntMontarField: {
      //   required: true
      // },
      // cpntMontarWhere: {
      //   required: true
      // },
      // cpntMontarOrder: {
      //   required: true
      // }
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        colunas: [],
        linhas: [],
        route: '',
        method: '',
        field: {},
        fieldVir: [],
        where: {},
        order: {},
        exportar: {
          format: [ 'xlsx', 'pdf' ],
          search: true,
          field: [
            { demandaId:               'Demanda Cód.'     },
            { demandaId_id_con_nome:   'Contato'          },
            { demandaId_data:          'Demanda Data'     },
            { item_codigo:             'Cód.'             },
            { item_nome:               'Nome'             },
            { qtde:                    'Qtde.'            },
            { valor_uni:               'Valor Unitário'   },
            { valor_uni_novo:          'Valor Unitário'   },
            { valor_tot_novo:          'Valor Total'      }
          ]
        }
      }
    },
    // mounted: function () {
    //   // SETA O STATUS DA PAGINA
    //   this.demRelPorContatoTabSetarStatusGeral('carregando')

    //   // CHAMA A FUNÇÃO PARA INICIAR O CARREGAMENTO
    //   this.demRelPorContatoTabIniciar()
    // },
    methods: {
      demRelPorContatoTabSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demRelPorContatoTabIniciar: function () {
        // CHAMA A FUNÇÃO PARA MONTAR O WHERE
        this.route = this.cpntMontarRouter(this.cpntDemanda)

        // CHAMA A FUNÇÃO PARA MONTAR O WHERE
        this.method = this.cpntMontarMethod(this.cpntDemanda)

        // CHAMA A FUNÇÃO PARA MONTAR O WHERE
        this.field = this.cpntMontarField(this.cpntDemanda)

        // CHAMA A FUNÇÃO PARA MONTAR O WHERE
        this.where = this.cpntMontarWhere(this.cpntDemanda)

        // CHAMA A FUNÇÃO PARA MONTAR O ORDER
        this.order = this.cpntMontarOrder(this.cpntDemanda)

        // SETA AS LINHAS DA TABELA
        if ([ '', null, undefined ].indexOf(this.cpntLinhas) === -1) {
          this.demRelPorContatoTabSetarLinhas(this.cpntLinhas)
        }

        // CHAMA A FUNÇÃO PARA ATUALIZAR OS DADOS DA TABELA
        this.demRelPorContatoTabSetarTotalRegistro()

        // SETA O STATUS DA PAGINA
        this.demRelPorContatoTabSetarStatusGeral('')
      },
      demRelPorContatoTabSetarLinhas: function (linhas) {
        // SETA OS IDS SOLICITADOS
        for (var index in linhas) {
          // SETA OS DADOS DO BOTÃO
          linhas[index]._demandaBT = {
            texto: this.demRelPorContatoTabMontarBotaoDemandaDocTexto(linhas[index]),
            class: (linhas[index].demandaId_status === '2' ? [ 'btn', 'btn-sm', 'btn-primary' ] : [ 'btn', 'btn-sm', 'btn-warning' ])
          }

          // CONVERTE O VALOR RECEBIDO
          if (this.cpntDemanda === 'venda_servico') {
            linhas[index].valor_uni = (Number(linhas[index].valor_uni) / 100).toFixed(2)
            linhas[index].valor_tot = (Number(linhas[index].valor_tot) / 100).toFixed(2)
          }

          // FORMATA O VALOR RECEBIDO
          linhas[index]._qtde = this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', linhas[index].qtde)

          // FORMATA O VALOR RECEBIDO
          linhas[index]._valor_uni = this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', linhas[index].valor_uni)

          // FORMATA O VALOR RECEBIDO
          linhas[index]._valor_tot = this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', linhas[index].valor_tot)
        }

        // SETA OS VALORES RECEBIDOS
        this.linhas = linhas

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demRelPorContatoTabMontarBotaoDemandaDocTexto: function (linha) {
        // FORMATA O VALOR RECEBIDO
        var valor = (linha.demandaId.length <= 4 ? ('0000' + linha.demandaId).slice(-4) : linha.demandaId)

        // RETORNA O VALOR MONTADO
        switch (this.cpntDemanda) {
          case 'venda_produto':
          case 'venda_servico':
            valor = ((linha.demandaId_status === '2' ? 'V' : 'O') + ' ' + valor)
            break
        
          case 'compra':
            valor = ((linha.demandaId_status === '2' ? 'C' : 'O') + ' ' + valor)
            break

          case 'dem_dev_cliente':
            valor = ('DC ' + valor)
            break

          case 'dem_dev_fornecedor':
            valor = ('DF ' + valor)
            break
        }

        // RETORNA O VALOR
        return valor
      },
      demRelPorContatoTabSetarTotalRegistro: function (tentativa = 0) {
        if (tentativa <= 10) {
          // SETA A FUNÇÃO DE REINICIAR
          var reiniciar = () => { setTimeout(() => { this.demRelPorContatoTabSetarTotalRegistro((tentativa + 1)) }, 100) }

          // VERIFICA SE O CAMPO EXISTE
          if (tentativa >= 2 && [ '', null, undefined ].indexOf(this.$refs.tabela) === -1 && [ '', null, undefined ].indexOf(this.cpntTotal) === -1) {
            // PEGA O ELEMENTO QUE DEVE DAR FOCUS
            var elemento = Array.isArray(this.$refs.tabela) === true ? this.$refs.tabela[0] : this.$refs.tabela

            // VERIFICA SE O ELEMENTO EXISTE
            if ([ '', null, undefined ].indexOf(elemento) === -1) {
              // SETA A QUANTIDADE DE REGISTROS
              elemento.rpp = Number(this.cpntRpp)
              elemento.paginacao.rpp.value = this.cpntRpp.toString()

              // SETA A QUANTIDADE DE REGISTROS
              elemento.total = Number(this.cpntTotal)

              // CHAMA A FUNÇÃO PARA CALCULAR A QUANTIDADE DE REGISTROS
              elemento.cpntApiTabCalcularQtdeRegistros()
            } else {
              reiniciar()
            }
          } else {
            reiniciar()
          }
        }
      },
      demRelPorContatoTabAbrirCadastro: function (linha, tipo) {
        // VERIFICA O TIPO DE REGISTRO
        if (typeof tipo === 'object') {
          tipo = tipo.id_ser !== undefined ? 'servico' : 'produto'
        }

        // SETA OS PARAMETROS QUE SERÁ ENVIADO
        var params = { editar: true, tipo: tipo, id: linha }

        // RETORNA O VALOR MONTADO
        switch (tipo) {
          case 'produto':
            params.id = linha.id_pro
            break
          case 'servico':
            params.id = linha.id_ser
            break
          case 'contato':
            params.editar = false
            break
        }

        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = (atualizar) => {
          if (atualizar === true) {
            this.$emit('UPDATE_TABELA')
          }
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },
      demRelPorContatoTabAbrirDemanda: function (demandaId) {
        // INICIA A VARIAVEL
        var params = ''

        // RETORNA O VALOR MONTADO
        switch (this.cpntDemanda) {
          case 'venda_produto':
          case 'venda_servico':
            params = { name: 'abrir_doc_id', params: { cts: this.$store.state.token.cts, nome: 'venda', id: demandaId, tipo: 'recibo', formato: 'html' } }
            break
        
          case 'compra':
            params = { name: 'abrir_doc_id', params: { cts: this.$store.state.token.cts, nome: 'compra', id: demandaId, tipo: 'recibo', formato: 'html' } }
            break

          case 'dem_dev_cliente':
            params = { name: 'dev_cliente_nova_numero', params: { cts: this.$store.state.token.cts, id: demandaId } }
            break

          case 'dem_dev_fornecedor':
            params = { name: 'dev_fornecedor_nova_numero', params: { cts: this.$store.state.token.cts, id: demandaId } }
            break
        }

        // ABRE O RECIBO DA DEMANDA SOLICITADO
        this.$store.state.OPEN_PAGE_CS(this.$router.resolve(params).href, '_blank', {}, false)
      },
      demRelPorContatoTabAbrirHistorico: function (linha) {
        // SETA O FILTRO DO CAMPO
        var params = {}

        // SETA O FILTRO PRODUTO CATEGORIA
        if (this.cpntFiltros.dem_sta !== '') {
          // INICIA O VETOR
          params.dem = []

          // INICIA O VETOR
          params.dem_sta = []

          // ADICIONA OS VALORES CORRETOS
          for (var indexDS in this.cpntFiltros.dem_sta) {
            switch (this.cpntDemanda) {
              case 'venda':
                // ADICIONA A DEMANAD
                params.dem.push('dem_venda')

                // ADICIONA O STATUS
                params.dem_sta.push('venda_' + this.cpntFiltros.dem_sta[indexDS])
                break
                
              case 'compra':
                // ADICIONA A DEMANAD
                params.dem.push('compra')
                  
                // ADICIONA O STATUS
                params.dem_sta.push('compra__' + this.cpntFiltros.dem_sta[indexDS])
                break
            }
          }
        }

        // SETA O FILTRO PRODUTO CATEGORIA
        if (this.cpntFiltros.pro_cat !== '') {
          params.pro_cat = this.cpntFiltros.pro_cat
        }
  
        // SETA O FILTRO PRODUTO MARCA
        if (this.cpntFiltros.pro_mar !== '') {
          params.pro_mar = this.cpntFiltros.pro_mar
        }

        // SETA O FILTRO DE DATA
        if (this.cpntFiltros.dat !== '') {
          params.dat = this.cpntFiltros.dat
        }

        // SETA O ID DO PRODUTO QUE DEVE SELECIONAR
        params.con = [ linha.demandaId_id_con.toString() ]  
  
        // SETA O FILTRO PRODUTO
        if (linha.id_pro !== undefined) {
          // SETA O ID DO PRODUTO QUE DEVE SELECIONAR
          params.pro = [ linha.id_pro.toString() ]  
          
          // CARREGA OS PARAMETROS
          params = { name: 'produto_historico_busca', params: { cts: this.$store.state.token.cts, cpntFiltros: window.btoa(JSON.stringify(params)) } }
        } else {
          // SETA O ID DO PRODUTO QUE DEVE SELECIONAR
          params.ser = [ linha.id_ser.toString() ]  
          
          // CARREGA OS PARAMETROS
          params = { name: 'servico_historico_busca', params: { cts: this.$store.state.token.cts, cpntFiltros: window.btoa(JSON.stringify(params)) } }
        }

        // ABRE O RECIBO DA DEMANDA SOLICITADO
        this.$store.state.OPEN_PAGE_CS(this.$router.resolve(params).href, '_blank', {}, false)
      }
    },
    watch: {
      cpntRpp: function () {
        this.demRelPorContatoTabSetarTotalRegistro()
      }
    }
  }
</script>
